import React from 'react';
import {ThemeProvider} from '@material-ui/core/styles'
import {generarTema} from './components/layout/MisTemas';
import {BrowserRouter as Router,Switch,Route,Redirect} from 'react-router-dom';
import Contenedor from './components/layout/Contenedor'
import Login from './components/auth/Login'
import AuthProvider from './components/context/AuthContext'
import GeneralesProvider from './components/context/GeneralesContext'
import { ToastContainer } from 'react-toastify';
import PaginaNo from './components/PaginaNo';
import Bitacora from './components/bitacora';
import Usuarios from "./components/Usuarios"
import Dashboard from './components/Dashboard';
import CatalogoMaquinaria from './components/CatalogoMaquinaria';
import RepoBitacora from './components/Reportes/RepoBitacora';
import RepoIncidencias from './components/Reportes/RepoIncidencias';
import CatalogoUbicacion from './components/CatalogoUbicacion'
import CatalogoMarca from './components/CatalogoMarca';
import 'react-toastify/dist/ReactToastify.css';
import CatalogoRefaccion from './components/CatalogoRefaccion';
import Seguro from './components/Seguro';
import DashboardDinamico from './components/DashboardDinamico';
import BitacoraVigilancia from './components/Vigilancia';
import RentaMaquinaria from './components/Renta';
import CatalogoProveedor from './components/CatalogoProveedor';

function App() {
   const [colorTema,setColorTema] = React.useState(false);
   React.useEffect(()=>{
     const auxColor= localStorage.getItem('ColorTheme');
     if ( auxColor===undefined || auxColor===null) 
     {
       localStorage.setItem('ColorTheme',colorTema);
     //  console.log("sin el tema");
     }
     else
     {  //console.log("cargando el tema");
       //console.log(JSON.parse(auxColor));
       setColorTema(JSON.parse(auxColor))    
     }
   },[])

  return (
    <AuthProvider>     
      <GeneralesProvider >
      <Router>
        <ThemeProvider theme={generarTema(colorTema)}>        
          <Contenedor  colorTema={colorTema} setColorTema={setColorTema}>
            <Switch>
              <Route exact path="/" component={Login}  />
              <Route exact path="/bitacora" component={ Bitacora}  />                           
              <Route exact path="/usuarios" component={ Usuarios}  />     
              <Route exact path="/reporte-bitacora" component={ RepoBitacora}  />     
              <Route exact path="/reporte-incidencia" component={ RepoIncidencias}  />     
              <Route exact path="/inicio" component={ Dashboard}  />     
              <Route exact path="/tablero" component={ DashboardDinamico}  />     
              <Route exact path="/vigilancia" component={ BitacoraVigilancia}  />     
              <Route exact path="/renta-maquinaria" component={ RentaMaquinaria}  />     
              <Route exact path="/catalogo-maquinaria" component={ CatalogoMaquinaria}  />     
              <Route exact path="/catalogo-ubicacion" component={ CatalogoUbicacion}  />     
              <Route exact path="/catalogo-marca" component={ CatalogoMarca}  />     
              <Route exact path="/catalogo-refaccion" component={ CatalogoRefaccion}  />     
              <Route exact path="/catalogo-proveedor" component={ CatalogoProveedor}  />     
              <Route exact path="/seguro" component={ Seguro}  />              
              <Route path="*" component={  PaginaNo } />
            </Switch>
          </Contenedor>
        </ThemeProvider>
        <ToastContainer autoClose={5000} closeOnClick/>
      </Router>    
      </GeneralesProvider>
    </AuthProvider>
  );
}

export default App;
